export enum Mode {
  Normal = 'Normal',
  Menu = 'Menu',
  Noon = 'Noon',
}
